import { RefreshCw } from 'lucide-react';

interface RefreshButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  className?: string;
  title?: string;
}

/**
 * Reusable refresh button component with loading spinner animation.
 * Commonly used in table headers to refresh data.
 */
export function RefreshButton({
  onClick,
  isLoading = false,
  className = '',
  title = 'Refresh data',
}: RefreshButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={isLoading}
      className={`flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-gray-700 transition-colors hover:bg-gray-200 disabled:opacity-50 ${className}`}
      title={title}
    >
      <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
    </button>
  );
}
